import { inject, Injectable } from '@angular/core';

import { ApiVersion } from 'app/shared/models';

import { StorageService } from './storageService';

const identifierKey = 'settings-identifier';
export const apiVersionKey = 'apiVersion';

@Injectable({ providedIn: 'root' })
export class ApiConfigStorageService {
    private storage = inject(StorageService);

    getApiConfigFromStorage() {
        return {
            identifier: this.storage.get<string>(identifierKey) ?? '',
            apiVersion: this.getApiVersionFromStorage(),
        };
    }

    putApiConfigToStorage({ apiVersion, identifier }: { apiVersion: ApiVersion; identifier: string }) {
        this.storage.store(identifierKey, identifier);
        this.putApiVersionToStorage(apiVersion);
    }

    putApiVersionToStorage(value: ApiVersion) {
        this.storage.store(apiVersionKey, value);
    }

    getApiVersionFromStorage() {
        return this.storage.get<ApiVersion>(apiVersionKey);
    }

    clearApiConfigFromStorage() {
        this.storage.clear(apiVersionKey);
        this.storage.clear(identifierKey);
    }
}
